import React, { useState, useEffect, Fragment } from "react";
import {CardElement, useStripe, useElements, Elements} from "@stripe/react-stripe-js";
import {connect} from "react-redux";



const CheckoutForm =(props)=>{

    const [succeeded, setSucceeded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState('');
    const [disabled, setDisabled] = useState(true);
    const stripe = useStripe();
    const elements = useElements();
    const csrf_token = document.getElementById('csrf-token')

    const cardStyle = {

            base: {
                color: '#32325d',
                fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
                fontSmoothing: 'antialiased',
                fontSize: '16px',
                '::placeholder': {
                    color: '#aab7c4'
                }
            },
            invalid: {
                color: '#fa755a',
                iconColor: '#fa755a'
            }
    };


    const handleChange = async (event) => {
        setDisabled(event.empty);
        setError(event.error ? event.error.message : "");
    };


    const handleSubmit = async ev => {

        ev.preventDefault();
        setProcessing(true);

        let  paymentMethod = null

        stripe.confirmCardSetup(props.intent.client_secret, {
            payment_method: {
                card: elements.getElement(CardElement)
            }
        }).then(result=>{

            if (result.error) {
                setError(`Erreur de transaction :  ${result.error.error.message}`);
                setProcessing(false);
            } else {
                paymentMethod = result.setupIntent.payment_method

                const args = {
                   'coupon': null,
                   'payment_method': paymentMethod,
                   'paycode': 'carte',
                    'tax': props.tax,
                    'amountHT': props.amountHT,
                    'total' : props.amountHT*props.tax,
                    'products' : props.products

                }

                axios.post('/Api/shop/init_commande',args )
                    .then(result=>{
                        console.log(result)

                        setError(null);
                        setProcessing(false);
                        setSucceeded(true);
                    }).catch(err=>console.log(err))
            }
        })

    };


    useEffect(()=>{
        (succeeded)?props.success(true):null;
    }, [succeeded])

    return (
        (succeeded)
            ? <div className={succeeded ? "result-message mt-3" : "result-message hidden"}>
                <p className={'alert alert-success'}>Oppération de payement réussie</p>
            </div>
            :<form id="payment-form" onSubmit={handleSubmit} >

                    <input type="hidden" name="payment_method" className="payment-method" />
                    <input type="hidden" name="total" value={props.amountHT*props.tax} />
                    <input type="hidden" name="paycode" value={'carte'} />

                    <CardElement id="card-element" options={cardStyle} onChange={handleChange}/>
                    <button className={'btn btn-secondary mt-3'}
                            type={"submit"}
                            disabled={processing || disabled || succeeded}
                            id="submit"
                    >
                    <span id="button-text">
                      {
                          (processing)
                              ?
                              <div className="spinner" id="spinner"><i className="fas fa-spinner fa-spin"></i> Traitement...
                              </div>
                              : "Payer"
                      }
                    </span>
                    </button>
                    {/* Show any error that happens when processing the payment */}
                    {error && (
                        <div className="alert alert-danger my-3" role="alert">
                            {error}
                        </div>
                    )}
                </form>
    );
}

const mapStateToProps = state => {
    return {
        stripePubKey: state.StripeReducer.pubKey,
        amountHT: state.ShopCartReducer.amountHT,
        tax: state.ShopCartReducer.tax,
        products: state.ShopCartReducer.products


    }
}

const mapDispatchTProps = dispatch => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchTProps)(CheckoutForm);



